import { render, staticRenderFns } from "./CompanyDocument.vue?vue&type=template&id=ee085002&scoped=true&"
import script from "./CompanyDocument.vue?vue&type=script&lang=ts&"
export * from "./CompanyDocument.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee085002",
  null
  
)

export default component.exports